import { useState } from "react"
import { connect } from "react-redux"
import { Box, Divider, Hidden, Popover, Typography } from "@mui/material"
import _ from 'lodash'
import LogoImage from '../../assets/Icons/Logo.png'
import UserIcon from '../../assets/Icons/user.svg'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useStyles } from './style'
import { userSignOut } from '../../appRedux/actions/Auth'

const Header = (props) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const { currentUser } = props
  const isCS = currentUser && !currentUser.is_installer
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <Box className={classes.container}>
      <Box className={classes.headerContent} display="flex" justifyContent="space-between" alignItems="center" px={2}>
        <Box display="flex" alignItems="center">
          <img src={LogoImage} className={classes.logoImage} alt='logo' />
          <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>{isCS ? "Grid Services Validation Portal" : "Grid Services - Installer Intake Portal"}</Typography>
        </Box>
        {props.isSignedInUser &&
          <>
            <Box className={classes.pointer} display="flex" alignItems="center" onClick={handleClick}>
              <img className={classes.avatar} src={UserIcon} alt="" />
              <Hidden smDown>
                <Typography className={classes.avatarText}>{`Hi ${_.get(props, 'currentUser.first_name', '')} ${_.get(props, 'currentUser.last_name', '')}`}</Typography>
              </Hidden>
              <ExpandMoreIcon />
            </Box>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              PaperProps={{
                className: classes.headerPaper,
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Hidden smUp>
                <Typography className={classes.popoverText}>{`Hi ${_.get(props, 'currentUser.first_name', '')} ${_.get(props, 'currentUser.last_name', '')}`}</Typography>
                <Divider />
              </Hidden>
              <Typography className={classes.typography}><a className={classes.linkStyle} href="mailto:gridservices@enphase.com" target="_blank" rel="noopener noreferrer">Contact Support</a></Typography>
              <Typography className={classes.typography} onClick={() => { handleClose(); props.userSignOut() }}>Log Out</Typography>
            </Popover>
          </>
        }
      </Box>
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser } = auth
  return { authUser, currentUser }
}

const mapDispatchToProps = dispatch => ({
  userSignOut: () => dispatch(userSignOut()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)